import type { ReferralCodePreview, ReferralConversion, ReferralMeResponse, ReferralShare, ReferralTerms } from "@/generated/api/types.gen"
import { errorCode, errorStatus } from "@/platform/api/errors"

export const REFERRAL_ME_KEY = ["referrals", "me"] as const

export const REFERRAL_ERROR_CODES = {
  alreadyPurchased: "marketplace.referral.already_purchased",
  existingLoans: "marketplace.referral.existing_loans",
  usageLimitReached: "marketplace.discount.usage_limit_reached",
  selfReferral: "marketplace.referral.self_referral",
  offerUnavailable: "marketplace.referral.offer_unavailable",
  notAvailable: "marketplace.referral.not_available",
  discountNotFound: "marketplace.discount.not_found",
  discountNotValid: "marketplace.discount.not_valid",
  discountBelowMinimum: "marketplace.discount.below_minimum",
  discountNoEligibleItems: "marketplace.discount.no_eligible_items",
} as const

export const isReferralNotTargeted = (error: unknown): boolean => errorCode(error) === REFERRAL_ERROR_CODES.notAvailable || errorStatus(error) === 404

export type { ReferralTerms, ReferralShare, ReferralConversion, ReferralMeResponse }
export type ReferralConversionStatus = ReferralConversion["status"]
export type ReferralCodeOffer = ReferralCodePreview
